import Component from '../inherited/Component';

export default class CountryProvinceSelector extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx);
    this._countryEl = this._elem.querySelector('[data-country-selector]');
    this._provinceEl = this._elem.querySelector('[data-province-selector]');
    this._provinceContainer = this._elem.querySelector('[data-province-container]');
  }

  mount() {
    this._countryEl.addEventListener('change', (e) => {
      this._countryHandler();
    });
    this._initCountry();
    this._initProvince();
  }

  _initCountry() {
    var t = this._countryEl.getAttribute('data-default');
    this._setSelectorByValue(this._countryEl, t);
    this._countryHandler();
  }

  _initProvince() {
    var t = this._provinceEl.getAttribute('data-default');
    t && this._provinceEl.options.length > 0 && this._setSelectorByValue(this._provinceEl, t);
  }

  _countryHandler() {
    var t = this._countryEl.options[this._countryEl.selectedIndex];
    var e = t.getAttribute('data-provinces');
    var n = JSON.parse(e);

    this._clearOptions(this._provinceEl);
    if (n && n.length === 0) {
      this._provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < n.length; i++) {
        t = document.createElement('option');
        t.value = n[i][0];
        t.innerHTML = n[i][1];
        this._provinceEl.appendChild(t);
      }
      this._provinceContainer.style.display = '';
    }
  }

  _setSelectorByValue(t, e) {
    for (var n = 0, i = t.options.length; n < i; n++) {
      var o = t.options[n];
      if (e === o.value || e === o.innerHTML) {
        t.selectedIndex = n;
        return n;
      }
    }
  }

  _clearOptions(t) {
    for (; t.firstChild; ) t.removeChild(t.firstChild);
  }
}
